<ng-container
  [ngTemplateOutlet]="template"
  [ngTemplateOutletContext]="{
    pageState: pageState$ | async
  }"
>
</ng-container>

<ng-template #template>
  <div flexLayout="column" flexLayoutAlign="start stretch" class="container">
    @if (users.length > 0) {
      <table mat-table matSort [dataSource]="users" (matSortChange)="sortChangeHandler($event)">
        <ng-container matColumnDef="profileFirstName">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Name</th>
          <td mat-cell *matCellDef="let element">
            {{ element.userName }}
          </td>
        </ng-container>
        <ng-container matColumnDef="email">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Email</th>
          <td mat-cell *matCellDef="let element">{{ element.userEmail }}</td>
        </ng-container>
        <ng-container matColumnDef="lastLoginDateTime">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Last Login</th>
          <td mat-cell *matCellDef="let element">
            {{ element.userLastLoginDate | date: "M/d/yy, HH:mm" }}
          </td>
        </ng-container>
        <ng-container matColumnDef="active">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>User State</th>
          <td mat-cell *matCellDef="let element">{{ element.active ? "Active" : "Inactive" }}</td>
        </ng-container>
        <ng-container matColumnDef="userRoles">
          <th mat-header-cell *matHeaderCellDef>Roles</th>
          <td mat-cell *matCellDef="let element">{{ element.userRoles }}</td>
        </ng-container>
        <ng-container matColumnDef="userTags">
          <th mat-header-cell *matHeaderCellDef>Tags</th>
          <td mat-cell *matCellDef="let element">{{ element.userTags }}</td>
        </ng-container>
        <ng-container matColumnDef="actions"  stickyEnd="true">
          <th mat-header-cell *matHeaderCellDef>Actions</th>
          <td mat-cell *matCellDef="let user">
            <div class="actions" flexFill flexLayout="row" flexLayoutAlign="end center">
              <button
                mat-icon-button
                [disableRipple]="true"
                *ngxPermissionsOnly="[permConst.Admin.User.Profile.Write]"
                [routerLink]="['/administration/user', user.userId]"
                [queryParams]="{ returnUrl: 'users' }"
              >
                <mat-icon>edit</mat-icon>
              </button>
            </div>
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>
        <tr
          mat-row
          *matRowDef="let user; columns: columnsToDisplay"
          [ngClass]="{ 'enabled-link': isRouterLinkEnabled }"
          (dblclick)="editUser(user.userId)"
        ></tr>
      </table>
    }
  </div>
</ng-template>
